import PropTypes from 'prop-types';
import useLockBodyScroll from '../../hooks/useLockBodyScroll';

const Overlay = ({ onEscape = () => {} }) => {
  useLockBodyScroll();

  const handleKeyDown = (event) => {
    // Check if the Esc key was pressed (key code 27)
    if (event.keyCode === 27) {
      onEscape();
    }
  };

  return (
    <div
      onClick={onEscape}
      onKeyDown={handleKeyDown}
      className="fixed inset-0 z-10 bg-black/50 backdrop-blur-md"
      tabIndex="0"
      role="button"
      aria-label="Close"
    />
  );
};

Overlay.propTypes = {
  onEscape: PropTypes.func,
};

export default Overlay;
